import { Capacitor } from '@capacitor/core'

export type SynapPlatform = 'web' | 'android' | 'ios'

const SYNAP_PLATFORMS = new Set<SynapPlatform>(['web', 'android', 'ios'])

const normalizePlatform = (value: string): SynapPlatform => {
  if (SYNAP_PLATFORMS.has(value as SynapPlatform)) {
    return value as SynapPlatform
  }
  return 'web'
}

/** Lê `Capacitor.isNativePlatform()` (WebView nativo vs browser/PWA). */
export const isNativePlatform = (): boolean => Capacitor.isNativePlatform()

/** Lê `Capacitor.getPlatform()` normalizado para o contrato Synap. */
export const getPlatform = (): SynapPlatform => normalizePlatform(Capacitor.getPlatform())
